import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "./Settings.css"
import FeatureSection from '../components/SettingsComponents/FeatureSection';
import { logEvent } from '../utils/logger';
import axios from 'axios';
import { PageHeader } from '../components/ui/Primitives';
import { memberProfileFromResponse } from '../utils/sessionData';


function Settings({ organization, orgMember }) {
  const [updatedOrganization, setUpdatedOrganization] = useState(organization);
  const [updatedOrgMember, setUpdatedOrgMember] = useState(orgMember);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  // <-- NEW: notify chat widget
  useEffect(() => {
    if (!isLoading && updatedOrgMember) {
      const iframe = document.getElementById('chat-iframe');
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage({ type: 'page.navigation', page: 'Receptionist' }, '*');
      }
    }
  }, [isLoading, updatedOrgMember]);

  useEffect(() => {
    async function fetchUserData() {
      setIsLoading(true); // Start loading

      try {
        const jwt_token = localStorage.getItem('jwt_authorization');

        if (!jwt_token) {
          navigate('/');
          return null;
        }

        const response = await axios.post(`${process.env.REACT_APP_BACKEND_HOST}/user`, { jwt_token });

        if (response.status === 200) {
          setUpdatedOrgMember(memberProfileFromResponse(response.data));
          setIsLoading(false); // Stop loading after user data is set
        }

        // fetch organization details
        const orgResponse = await axios.post(
          `${process.env.REACT_APP_BACKEND_HOST}/organization`,
          { jwt_token }
        );
        if (orgResponse.status === 200) {
          setUpdatedOrganization(orgResponse.data.organization);
        }

      } catch (err) {
        if (err.response.status === 401) {
          localStorage.removeItem('jwt_authorization');
          navigate('/');
        }
        setIsLoading(false); // Stop loading in case of error
      }
    }

      fetchUserData();

      const event = {
        event: {
          label: 'PageView',
          data: {
            page: 'Receptionist',
            user_id: orgMember ? orgMember.id : null
          }
        }
  
      }
  
      logEvent(event);

  }, []);


  if (!isLoading && updatedOrgMember && updatedOrganization) { // Render only when not loading and user data is available
    return (
      <div>
        {/* <Sidebar user={user} /> */}
        <div className="page-content mobile-features receptionist-page">
          <PageHeader
            eyebrow="Receptionist"
            title="Design every caller experience"
            description="Shape how Sayable sounds, decide what happens for each caller intent, and publish changes when they are ready."
          />
          <FeatureSection organization={updatedOrganization} orgMember={updatedOrgMember} />
        </div>

      </div>
    );
  } else {

    return (
        <div className="page-content">

        </div>

    );
  }

}

export default Settings;
